"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = require("styled-components");
var cssVars_1 = require("../helpers/cssVars");
var bpMax = Object.keys(cssVars_1.cssVars.breakpoints).reduce(function (acc, label) {
    acc[label] = function (literals) {
        var placeholders = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            placeholders[_i - 1] = arguments[_i];
        }
        return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        @media (max-width: ", "px) {\n            ", "\n        }\n    "], ["\n        @media (max-width: ", "px) {\n            ", "\n        }\n    "])), cssVars_1.cssVars.breakpoints[label], styled_components_1.css.apply(void 0, __spreadArrays([literals], placeholders)));
    };
    return acc;
}, {});
exports.default = bpMax;
var templateObject_1;
